import Form from './components/Form'
import Table from './components/Table'
import * as S from './MovementsTab.styles'

export default () => (
  <S.Wrapper>
    <Form />
    <Table />
  </S.Wrapper>
)
